{% block sw_cms_sidebar_block_overview_category_options %}
    {% parent() %}
    <option value="acris-blog">{{ $tc('acris-blog.detail.label.blockBlogLayout') }}</option>
{% endblock %}

